import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-analyticslinkedinsummary',
  templateUrl: './analyticslinkedinsummary.component.html',
  styleUrls: ['./analyticslinkedinsummary.component.css']
})
export class AnalyticslinkedinsummaryComponent implements OnInit {
  @Input('details') details: any;
  @Input('linkedin_passed_arr') linkedin_passed_arr: any;
  @Input('linkedin_failed_arr') linkedin_failed_arr: any;
  @Input('analytics') analytics: any;

  constructor() {
  }

  ngOnInit() {
    //console.log(this.linkedin_failed_arr, this.linkedin_passed_arr);
  }


}
